import {
  MfaCompleteVerificationRequestData,
  MfaStartAttributeVerificationResponseData,
  MfaVerificationRequestData,
} from '@mobi/api-types/src/mfa'
import { invalidateCognitoUserQuery } from '@core/Data/Account/useCognitoUser'
import { queryClient } from '@core/Data/ReactQuery'
import { post } from '@core/Services/ApiService'
import { throwApiError } from '../Helpers/utils'
import {
  CognitoUnauthorizedError,
  isCognitoUserAuthenticated,
} from './useCognitoUserIsAuthenticated'

export async function startCognitoAttributeVerification(body: MfaVerificationRequestData) {
  const isAuthenticated = await isCognitoUserAuthenticated(true)

  if (!isAuthenticated) {
    throw new CognitoUnauthorizedError()
  }

  try {
    const response = await post<MfaStartAttributeVerificationResponseData>({
      url: '/api/mfa/start-verification',
      body,
    })
    return response
  } catch (error: unknown) {
    return throwApiError(error)
  }
}

export const useMfaCompleteVerification = () => {
  async function completeVerification(body: MfaCompleteVerificationRequestData) {
    try {
      const response = await post<void>({
        url: '/api/mfa/complete-verification',
        body,
      })

      invalidateCognitoUserQuery(queryClient)

      return response
    } catch (error: unknown) {
      return throwApiError(error)
    }
  }
  return { completeVerification }
}
